import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, ParamMap, ActivatedRouteSnapshot, Router } from '@angular/router';
import { ContentfulService } from '../_services/contentful.service';
import { SlugifyPipe } from '../../core/_pipes/slugify.pipe';

@Injectable({ providedIn: 'root' })
export class ProjectRedirectGuard implements CanActivate {
  constructor(
    private slugifyPipe: SlugifyPipe,
    private contentfulService: ContentfulService,
    private router: Router) { }

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean | import('@angular/router').UrlTree> {
    const id = route.params.id;
    const projectItem = await this.contentfulService.getProjectById(id);
    if (projectItem && projectItem.fields && projectItem.fields.client && projectItem.fields.slug) {
      return this.router.createUrlTree(['/work', this.slugifyPipe.transform(projectItem.fields.client), projectItem.fields.slug, id]);
    } else {
      return this.router.createUrlTree(['/404']);
    }
  }
}
